<template>
  <div class="px-5 pb-5" style="height: 100%; overflow: auto">
    <div>
      <div class="d-flex align-center px-0 py-2">
        <span class="pa-3 grey lighten-3 rounded">
          <v-icon>mdi-alert-circle-outline</v-icon>
        </span>
        <div class="ml-2">Set Firmware</div>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="
            command.status === 'connect' || command.status === 'process'
          "
          color="primary"
          outlined
          @click="handleSendCommand"
          >{{ sendCommandCount > 0 ? 'ส่งคำสั่งอีกครั้ง' : 'ส่งคำสั่ง' }}</v-btn
        >
      </div>
    </div>
    <v-divider></v-divider>
    <div class="px-0 py-2">
      <v-form ref="form" lazy-validation>
        <label class="body-2">
          เลือก Firmware
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-autocomplete
          v-model="firmware"
          :loading="firmwareLoading"
          :items="firmwares"
          :rules="[(v) => !!v || 'โปรดระบุเฟิร์มแวร์']"
          :disabled="
            command.status === 'connect' || command.status === 'process'
          "
          outlined
          dense
          color="blue-grey lighten-2"
          item-text="text"
          item-value="firmware_uuid"
        >
        </v-autocomplete>
      </v-form>
    </div>
    <div>
      <v-alert
        v-if="command.status === 'connect'"
        outlined
        type="info"
        icon="mdi-swap-horizontal"
        text
        dense
      >
        <div>กำลังติดต่อ Device</div>
        <div style="font-size: 11px; color: #333">
          {{ dateTimeFromNow(command.date) }}
        </div>
      </v-alert>
      <v-alert
        v-if="command.status === 'process'"
        outlined
        type="info"
        icon="mdi-autorenew"
        text
        dense
      >
        <div>รอ Device ดำเนินการ</div>
        <div style="font-size: 11px; color: #333">
          {{ dateTimeFromNow(command.date) }}
        </div>
      </v-alert>
      <v-alert
        v-if="command.status === 'success'"
        outlined
        type="success"
        icon="mdi-check-circle-outline"
        text
        dense
      >
        <div>สำเร็จ</div>
        <div style="font-size: 11px; color: #333">
          {{ dateTimeFromNow(command.date) }}
        </div>
      </v-alert>
      <v-alert
        v-if="command.status === 'fail'"
        outlined
        type="error"
        icon="mdi-close-circle-outline"
        text
        dense
      >
        <div>ไม่สำเร็จ</div>
        <div style="font-size: 11px; color: #333">
          {{ dateTimeFromNow(command.date) }}
        </div>
      </v-alert>
      <div v-if="command.status === 'success'">
        <v-list-item
          two-line
          v-for="(value, key) in command.responseData"
          :key="key"
        >
          <v-list-item-content>
            <v-list-item-title>{{ key.toUpperCase() }}</v-list-item-title>
            <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
              {{ value }}
            </p>
          </v-list-item-content>
        </v-list-item>
      </div>
      <div v-if="command.status === 'fail'">
        <v-list-item
          two-line
          v-for="(value, key) in command.responseData"
          :key="key"
        >
          <v-list-item-content>
            <v-list-item-title>{{ key.toUpperCase() }}</v-list-item-title>
            <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
              {{ value }}
            </p>
          </v-list-item-content>
        </v-list-item>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

import { mapActions } from 'vuex'

export default {
  props: {
    hardware: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      command: {
        status: null,
        date: null,
        responseData: null,
      },
      syncJobId: null,
      firmware: null,
      firmwareLoading: true,
      sendCommandCount: 0,
    }
  },

  computed: {
    firmwares() {
      const { company_uuid } = this.$store.state.authentication.company

      return this.$store.state.firmware.firmwares
        .filter(
          (firmware) =>
            firmware.hardware_model.hardware_model_code ===
              this.hardware.hardware_model.hardware_model_code ||
            (firmware.company?.company_uuid === company_uuid &&
              firmware.hardware_model.hardware_model_code ===
                this.hardware.hardware_model.hardware_model_code)
        )
        .map((firmware) => ({
          firmware_uuid: firmware.firmware_uuid,
          text: `${firmware.hardware_model.title} : ${
            firmware.firmware_version
          } : ${moment(firmware.updated_at).format('DD/MM/YYYY HH:mm')}`,
        }))
    },
  },

  async created() {
    try {
      this.firmwareLoading = true

      await this.fetchFirmwares()
    } catch (error) {
      const snackbar = {
        show: true,
        color: 'error',
        timeout: -1,
        message: error?.response?.data?.message || 'Something went wrong!',
      }
      this.$store.commit('SET_SNACKBAR', snackbar)
    } finally {
      this.firmwareLoading = false
    }
  },

  methods: {
    ...mapActions({
      fetchFirmwares: 'firmware/fetchFirmwares',
      setFirmware: 'hardware/setFirmware',
      fetchJob: 'hardware/fetchJob',
      userAcknowledge: 'hardware/userAcknowledge',
    }),

    async handleSendCommand() {
      if (this.$refs.form.validate()) {
        try {
          const { company_uuid } = this.$store.state.authentication.company

          const payload = {
            company_uuid,
            hardware_model: this.hardware.hardware_model.hardware_model_code,
            body: {
              hardware_uuid: this.hardware.hardware_uuid,
              data: {
                firmware_uuid: this.firmware,
              },
            },
          }

          const response = await this.setFirmware(payload)

          this.command = {
            status: 'connect',
            date: response.create_datetime,
          }
          this.syncJob(response.sync_job_uuid)

          this.sendCommandCount++
        } catch (error) {
          if (error.response && error.response.data) {
            this.command = {
              status: 'fail',
              date: new Date(),
              responseData: {
                Type: 'Set Firmware Fail',
                Message: error.response.data.message || 'Error',
              },
            }
          }
        }
      }
    },

    syncJob(sync_job_uuid) {
      this.syncJobId = setInterval(() => {
        this.fetchJob(sync_job_uuid).then((res) => {
          this.analyzeStatus(res)
        })
      }, 1000)
    },

    clearSyncJob() {
      clearInterval(this.syncJobId)
    },

    analyzeStatus(res) {
      if (res.done_datetime && res.is_response_success) {
        this.command = {
          status: 'success',
          date: res.done_datetime,
          responseData: res.response_json,
        }
        this.clearSyncJob()
        // User Acknowledge
        if (res.user_acknowledge_datetime === null) {
          this.acknowledge(res.sync_job_uuid)
        }
      } else if (res.done_datetime && !res.is_response_success) {
        this.command = {
          status: 'fail',
          date: res.done_datetime,
          responseData: {
            Type: res.response_json?.error_type || 'Error Type',
            Message: res.response_json?.error_message || 'Error Message',
          },
        }
        this.clearSyncJob()
        // User Acknowledge
        if (res.user_acknowledge_datetime === null) {
          this.acknowledge(res.sync_job_uuid)
        }
      } else if (res.notice_datetime) {
        this.command = {
          status: 'process',
          date: res.notice_datetime,
        }
      }
    },

    acknowledge(sync_job_uuid) {
      this.userAcknowledge(sync_job_uuid).catch((error) => {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      })
    },

    dateTimeFromNow(value) {
      return moment.utc(value, 'YYYY-MM-DD HH:mm:ss').locale('th').fromNow()
    },
  },

  beforeDestroy() {
    this.clearSyncJob()
  },
}
</script>
